import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent {
  @Input() color: string;
  @Input() icon: string;
  @Input() width?: string;
  @Input() stroke?: boolean;
}
